document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]'),nav=document.querySelector('[data-nav]');
  if(toggle&&nav)toggle.addEventListener('click',()=>{const isOpen=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',isOpen?'true':'false')});

  document.addEventListener('click',function(event){
    const prev=event.target.closest('[data-variant-prev]');
    const next=event.target.closest('[data-variant-next]');
    if(prev||next){
      const slider=(prev||next).closest('[data-variant-slider]');
      const track=slider&&slider.querySelector('[data-variant-track]');
      if(!track)return;
      track.scrollBy({left:prev?-150:150,behavior:'smooth'});
      return;
    }

    const buyNow=event.target.closest('[data-buy-now]');
    if(buyNow && buyNow.closest('[data-product-card]')){
      event.preventDefault();
      if(buyNow.disabled)return;
      const variantId=buyNow.dataset.variantId;
      if(!variantId)return;
      const originalText=buyNow.textContent;
      buyNow.disabled=true;
      buyNow.classList.add('is-loading');
      buyNow.textContent='LOADING CHECKOUT…';
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
      })
      .then(response=>{if(!response.ok)throw new Error('Unable to add item');return response.json()})
      .then(()=>{window.location.assign('/checkout')})
      .catch(()=>{window.location.assign('/cart/'+variantId+':1?checkout')})
      .finally(()=>{setTimeout(()=>{buyNow.disabled=false;buyNow.classList.remove('is-loading');buyNow.textContent=originalText},2500)});
      return;
    }

    const chip=event.target.closest('[data-variant-chip]');
    if(!chip||chip.disabled)return;
    event.preventDefault();
    const card=chip.closest('[data-product-card]');
    if(!card)return;

    card.querySelectorAll('[data-variant-chip]').forEach(item=>item.classList.toggle('is-active',item===chip));

    const price=card.querySelector('[data-product-price]');
    if(price&&chip.dataset.variantPrice)price.textContent=chip.dataset.variantPrice;

    const buyNowButton=card.querySelector('[data-buy-now]');
    if(buyNowButton&&chip.dataset.variantId){
      const available=chip.dataset.variantAvailable!=='false';
      buyNowButton.dataset.variantId=chip.dataset.variantId;
      buyNowButton.disabled=!available;
      buyNowButton.setAttribute('aria-disabled',available?'false':'true');
      buyNowButton.textContent=available?'Buy Now':'Sold Out';
    }

    card.querySelectorAll('[data-product-link]').forEach(link=>{if(chip.dataset.variantUrl)link.href=chip.dataset.variantUrl});

    const primaryImage=card.querySelector('.product-card__image--primary');
    if(primaryImage&&chip.dataset.variantImage){primaryImage.src=chip.dataset.variantImage;primaryImage.removeAttribute('srcset')}
  });

  const product=document.querySelector('[data-product-page]');
  if(product){
    const idInput=product.querySelector('[name="id"]');
    product.querySelectorAll('[data-variant-button]').forEach(b=>b.addEventListener('click',()=>{
      product.querySelectorAll('[data-variant-button]').forEach(x=>x.classList.remove('active'));
      b.classList.add('active');
      idInput.value=b.dataset.variant;
      const p=product.querySelector('[data-main-price]');if(p)p.textContent=b.dataset.price;
      const atc=product.querySelector('[data-atc]');atc.disabled=b.dataset.available!=='true';atc.textContent=b.dataset.available==='true'?'ADD TO CART':'SOLD OUT';
    }));
    const buy=product.querySelector('[data-buy-now]');
    if(buy)buy.addEventListener('click',async()=>{const id=idInput.value;await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(id),quantity:1})});location.href='/checkout'});
  }
});
